import { setBorder } from './setBorder.js';

const drawLegacyCanvasDrawing = ({
  ctx,
  canvasSize,
  strokeWidth = 0.5,
  item
}) => {
  const firstPoint = item.points[0];
  if (firstPoint === undefined) {
    return;
  }
  ctx.strokeStyle = item.style.stroke.color;
  setBorder(ctx, "solid", strokeWidth);
  ctx.beginPath();
  ctx.moveTo(...getNormalizedCoordinate(firstPoint, item, canvasSize));
  for (const point of item.points) {
    ctx.lineTo(...getNormalizedCoordinate(point, item, canvasSize));
  }
  ctx.globalAlpha = 1;
  ctx.lineCap = "round";
  ctx.stroke();
};
function getNormalizedCoordinate(coordinate, item, canvasSize) {
  return [(item.position.x + coordinate.x * item.size.width) * canvasSize.width, (item.position.y + coordinate.y * item.size.height) * canvasSize.height];
}

export { drawLegacyCanvasDrawing };
//# sourceMappingURL=drawLegacyCanvasDrawing.js.map
